export const courseLibrary = [
  {
    id: 1,
    title: "Introduksjon til psykososialt arbeidsmiljø",
    duration: "2 timer",
    level: "Alle",
    price: "1 200,-",
    category: "Grunnleggende",
    img: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=400",
    description: "En grunnleggende innføring i hva som skaper et godt arbeidsmiljø og lovverkets krav."
  },
  {
    id: 2,
    title: "Arbeidsmiljøloven i praksis",
    duration: "4 timer",
    level: "Leder/HR",
    price: "2 900,-",
    category: "Lovverk",
    img: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?auto=format&fit=crop&q=80&w=400",
    description: "Gjennomgang av de viktigste paragrafene for ledere og tillitsvalgte."
  },
  {
    id: 3,
    title: "Psykologisk trygghet",
    duration: "2 timer",
    level: "Alle",
    price: "1 500,-",
    category: "Kultur",
    img: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&q=80&w=400",
    description: "Hvordan skape en kultur der alle tør å si sin mening og lære av feil."
  },
  {
    id: 4,
    title: "Forståelse av konflikter",
    duration: "3 timer",
    level: "Alle",
    price: "1 800,-",
    category: "Konflikt",
    img: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&q=80&w=400",
    description: "Lær å kjenne igjen ulike konflikttyper og eskaleringstrinn."
  },
  {
    id: 5,
    title: "Konfliktmekling",
    duration: "6 timer",
    level: "Leder/HR",
    price: "4 500,-",
    category: "Konflikt",
    img: "https://images.unsplash.com/photo-1521791136364-798a7bc0d262?auto=format&fit=crop&q=80&w=400",
    description: "Praktiske verktøy for å fasilitere løsninger mellom parter i konflikt."
  },
  {
    id: 6,
    title: "Ledelse og trivsel",
    duration: "4 timer",
    level: "Ledere",
    price: "3 200,-",
    category: "Ledelse",
    img: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&q=80&w=400",
    description: "Hvordan lederadferd direkte påvirker teamets helse og prestasjoner."
  },
  {
    id: 7,
    title: "Kommunikasjonsferdigheter",
    duration: "3 timer",
    level: "Alle",
    price: "1 600,-",
    category: "Samarbeid",
    img: "https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80&w=400",
    description: "Trening i aktiv lytting, tydelig tale og ikke-verbal kommunikasjon."
  },
  {
    id: 8,
    title: "Stressmestring",
    duration: "2 timer",
    level: "Alle",
    price: "950,-",
    category: "Helse",
    img: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&q=80&w=400",
    description: "Praktiske teknikker for å håndtere krysspress og høyt arbeidstempo."
  },
  {
    id: 9,
    title: "Forebygging av mobbing",
    duration: "3 timer",
    level: "Alle",
    price: "1 400,-",
    category: "Arbeidsmiljø",
    img: "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&q=80&w=400",
    description: "Identifisering av risikofaktorer og rutiner for varsling og oppfølging."
  },
  {
    id: 10,
    title: "Bygge sterke team",
    duration: "4 timer",
    level: "Ledere",
    price: "2 800,-",
    category: "Teamutvikling",
    img: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&q=80&w=400",
    description: "Faser i teamutvikling og hvordan skape felles mål og retning."
  },
  {
    id: 11,
    title: "Organisasjonskultur",
    duration: "3 timer",
    level: "Alle",
    price: "1 700,-",
    category: "Kultur",
    img: "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?auto=format&fit=crop&q=80&w=400",
    description: "Hvordan forstå og endre de uformelle spillereglene i bedriften."
  },
  {
    id: 12,
    title: "Den vanskelige samtalen",
    duration: "4 timer",
    level: "Ledere",
    price: "3 500,-",
    category: "Ledelse",
    img: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=400",
    description: "Metodikk for å gjennomføre korrigerende samtaler på en respektfull måte."
  },
  {
    id: 13,
    title: "Endringsledelse",
    duration: "5 timer",
    level: "Ledere",
    price: "3 900,-",
    category: "Ledelse",
    img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=400",
    description: "Psykologiske reaksjoner på endring og hvordan lede gjennom usikkerhet."
  },
  {
    id: 14,
    title: "Strategi for arbeidsmiljø",
    duration: "6 timer",
    level: "HR/Toppledelse",
    price: "5 500,-",
    category: "Strategi",
    img: "https://images.unsplash.com/photo-1454165833767-027ffea10c3b?auto=format&fit=crop&q=80&w=400",
    description: "Hvordan integrere arbeidsmiljø som en del av forretningsstrategien."
  },
  {
    id: 15,
    title: "Ledelse av helsefremmende arbeidsplasser",
    duration: "4 timer",
    level: "Ledere",
    price: "3 200,-",
    category: "Ledelse",
    img: "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&q=80&w=400",
    description: "Fokus på faktorer som skaper engasjement, mening og god helse."
  }
];